import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Location } from 'src/app/models/common-models';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationListComponent {
  @Input() locations: Location[] | null = [];
  @Input() selectedId: number | null = null;
  @Input() newestLocationId: number | null = null;
  @Output() select = new EventEmitter<number>();

  trackById = (_: number, item: Location) => item.Id;
}
